import { createFileRoute } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { useState } from "react";
import { EmptyState } from "@/components/brand/empty-state";
import { ErrorState } from "@/components/brand/error-state";
import { PageHeader } from "@/components/layout/page-header";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { CreateTemplateDialog, TemplateCard, useTemplates } from "@/features/brand-templates";

export const Route = createFileRoute("/_authenticated/admin/templates/")({
  component: BrandTemplatesPage,
});

function BrandTemplatesPage() {
  const { data, isPending, isError, refetch } = useTemplates();
  const [creating, setCreating] = useState(false);

  return (
    <>
      <PageHeader
        eyebrow="The Motherhood"
        title="Brand templates"
        description="Reusable brand setups for a kind of organisation. Pick one when you create a new client and their brand is configured in a single step."
        actions={
          <Button onClick={() => setCreating(true)}>
            <Plus /> New template
          </Button>
        }
      />

      {isPending ? (
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {[0, 1, 2].map((i) => (
            <Skeleton key={i} className="h-56 rounded-lg" />
          ))}
        </div>
      ) : isError ? (
        <ErrorState
          title="Could not load templates"
          description="The list did not come back. Try again in a moment."
          onRetry={() => void refetch()}
        />
      ) : data.items.length === 0 ? (
        <EmptyState
          title="No templates yet"
          description="Build one for a kind of organisation you work with often, for example healthcare nonprofits or manufacturers. Every new client of that kind then starts from it."
          action={
            <Button onClick={() => setCreating(true)}>
              <Plus /> Create the first template
            </Button>
          }
        />
      ) : (
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {data.items.map((template) => (
            <TemplateCard key={template.id} template={template} />
          ))}
        </div>
      )}

      <CreateTemplateDialog open={creating} onOpenChange={setCreating} />
    </>
  );
}
